import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -15,
      marginLeft: -15
    }
  }
}))

export default useStyles
